import { useParams } from 'react-router';
import { useUnitWorkloadData } from '@/hooks';
import { UnitWorkloadHeader } from '../Common/UnitWorkloadHeader';
import { UnitWorkloadNavigation } from '../Common/UnitWorkloadNavigation';
import { TdTrdPanel } from '../Common/TdTrdPanel';
import { UnitTeachingDelivery } from './UnitTeachingDelivery';
import { Loader } from '@/components/Common/Loader';

export const UnitTeachingDeliveryView = () => {
  const { unitWorkloadId } = useParams();
  const uwId = unitWorkloadId ? parseInt(unitWorkloadId, 10) : null;
  if (uwId === null || isNaN(uwId)) {
    throw new Error('unitWorkloadId is required and must be a valid number');
  }

  const { unitWorkloadDetails, unitWorkloadCampuses, isPageLoading } = useUnitWorkloadData(uwId);

  if (isPageLoading) {
    return <Loader />;
  }

  return (
    unitWorkloadDetails &&
    unitWorkloadCampuses && (
      <div className="flex h-full w-screen flex-col items-start overflow-auto">
        <UnitWorkloadHeader unitWorkloadDetails={unitWorkloadDetails} />
        <UnitWorkloadNavigation unitWorkloadDetails={unitWorkloadDetails} />
        <div className="flex h-full w-screen flex-row items-stretch justify-start gap-14 overflow-auto bg-white">
          <TdTrdPanel
            unitWorkloadId={uwId}
            unitWorkloadDetails={unitWorkloadDetails}
            unitWorkloadCampuses={unitWorkloadCampuses}
          />
          <UnitTeachingDelivery unitWorkloadId={uwId} />
        </div>
      </div>
    )
  );
};
